import Vue from 'vue'
import Router from 'vue-router'
import SiteLayout from "@/components/SiteLayout"
import LoginLayout from "@/pages/Login/LoginLayout"
import { FooterRoute } from "site-footer"
import store from '@/store'
Vue.use(Router)

//进入业务页前
const beforeSiteLayoutEnter = async function (to, from, next) {
    await store.dispatch("loadGlobalConfig");

    next()
}

const router = new Router({
    mode: process.env.NODE_ENV == 'production' ? "history" : 'hash',
    base: process.env.NODE_ENV == 'production' ? "/applicant/" : "/",
    routes: [
        {
            path: "/layout",
            name: 'LoginLayout',
            component: LoginLayout,
            redirect: {
                name: "Login"
            },
            meta: {
                tokenDisable: true
            },
            children: [
                {
                    path: '/login',
                    name: 'Login',
                    component: resolve => require(['@/pages/Login/pages/enterpriseLog'], resolve),
                    props: route => ({
                        loginToken: route.query.loginToken,
                        isNewAccount: route.query.newAccount == "true",
                        overLimit: route.query.overLimit == "true"
                    }),
                    meta: {
                        tokenDisable: true,
                    },
                },
                {
                    path: '/register',
                    name: 'Register',
                    component: resolve => require(['@/pages/Login/pages/enterpriseReg'], resolve),
                    meta: {
                        tokenDisable: true,
                    },
                },
                {
                    path: '/reset-password',
                    name: 'ResetPassword',
                    component: resolve => require(['@/pages/Login/pages/enterpriseResetPwd'], resolve),
                    meta: {
                        tokenDisable: true,
                    },
                },
                {
                    path: '/reset-password/email',
                    name: 'emailChangePwd',
                    component: resolve => require(['@/pages/Login/pages/EmailResetPassword'], resolve),
                    props: route => ({
                        email: route.query.email,
                        token: route.query.token,
                    }),
                    meta: {
                        tokenDisable: true,
                    },
                },
            ]
        },
        {
            path: "",
            name: "SiteLayout",
            component: SiteLayout,
            redirect: {
                name: "Home"
            },
            beforeEnter: beforeSiteLayoutEnter,
            children: [
                {
                    path: '/error',
                    name: "Error",
                    component: resolve => require(['@/pages/Error'], resolve),
                    props: route => ({
                        message: route.query.message
                    }),
                },
                {
                    path: '/home',
                    name: 'Home',
                    component: resolve => require(['@/pages/Home'], resolve),
                    meta: {
                        title: '贝猎网-注册简历，等待贝猎'
                    }
                },
                {
                    path: '/safetyCenter',
                    name: 'safetyCenter',
                    component: resolve => require(['@/pages/safetyCenter'], resolve),
                    meta: {
                        title: '贝猎网-安全中心'
                    }
                },
                {
                    path: '/basicCard',
                    name: 'basicCard',
                    redirect: '/basicCard/firstStep',
                    component: resolve => require(['@/pages/basicCard'], resolve),
                    children: [{
                        path: 'firstStep',
                        name: 'firstStep',
                        component: resolve => require(['@/pages/basicCard/components/firstStep'], resolve),
                        meta: {
                            title: "贝猎网-完善信息"
                        }
                    },
                    {
                        path: 'twoStep',
                        name: 'twoStep',
                        component: resolve => require(['@/pages/basicCard/components/twoStep'], resolve),
                        meta: {
                            title: "贝猎网-完善信息"
                        }
                    },
                    {
                        path: 'lastStep',
                        name: 'lastStep',
                        component: resolve => require(['@/pages/basicCard/components/lastStep'], resolve),
                        meta: {
                            title: "贝猎网-完善信息"
                        }
                    },
                    {
                        path: 'newStep',
                        name: 'newStep',
                        component: resolve => require(['@/pages/basicCard/components/newStep'], resolve),
                        meta: {
                            title: "贝猎网-完善信息"
                        }
                    }
                    ]
                },
                {
                    path: '/resume',
                    name: 'resume',
                    component: resolve => require(['@/pages/resume'], resolve),
                    meta: {
                        title: '贝猎网-我的简历'
                    }
                },

                {
                    path: '/resumeSetting',
                    name: 'resumeSetting',
                    component: resolve => require(['@/pages/resumeSetting'], resolve),
                    meta: {
                        title: '贝猎网-隐私设置'
                    }
                },
                {
                    path: '/previewResume',
                    name: 'previewResume',
                    component: resolve => require(['@/pages/previewResume'], resolve),
                    meta: {
                        title: "贝猎网-预览简历"
                    }
                },
                {
                    path: '/human',
                    name: 'human',
                    component: resolve => require(['@/pages/human'], resolve),
                },
                {
                    path: '/position',
                    name: 'position',
                    component: resolve => require(['@/pages/position'], resolve),
                    meta: {
                        title: '贝猎网-职位搜索'
                    }
                },
                {
                    path: "/positionDetail",
                    name: 'positionDetail',
                    component: resolve => require(['@/pages/positionDetail'], resolve),
                    meta: {
                        title: '贝猎网-职位详情'
                    }
                },
                {
                    path: "/companyPositionDetail",
                    name: 'companyPositionDetail',
                    component: resolve => require(['@/pages/companyPositionDetail'], resolve),
                    meta: {
                        title: '贝猎网-职位详情'
                    }
                },
                {
                    path: '/positionTypes',
                    name: 'positionTypes',
                    component: resolve => require(['@/pages/positionTypes'], resolve),
                    children: [{
                        path: 'myDelivery',
                        name: 'myDelivery',
                        component: resolve => require(['@/pages/positionTypes/components/myDelivery'], resolve),
                        meta: {
                            title: "贝猎网-我的投递"
                        }
                    },
                    {
                        path: 'myEntrust',
                        name: 'myEntrust',
                        component: resolve => require(['@/pages/positionTypes/components/myEntrust'], resolve),
                        meta: {
                            title: "贝猎网-我的委托"
                        }
                    },
                    {
                        path: 'myAttention',
                        name: 'myAttention',
                        component: resolve => require(['@/pages/positionTypes/components/myAttention'], resolve),
                        meta: {
                            title: "贝猎网-我的关注"
                        }
                    },
                    {
                        path: 'myCollectionPosition',
                        name: 'myCollectionPosition',
                        component: resolve => require(['@/pages/positionTypes/components/myCollectionPosition'], resolve),
                        meta: {
                            title: "贝猎网-我的收藏"
                        }
                    },
                    {
                        path: 'browsingHistory',
                        name: 'browsingHistory',
                        component: resolve => require(['@/pages/positionTypes/components/browsingHistory'], resolve),
                        meta: {
                            title: "贝猎网-已浏览的职位"
                        }
                    },
                    {
                        path: 'JobSubscription',
                        name: 'JobSubscription',
                        component: resolve => require(['@/pages/positionTypes/components/JobSubscription'], resolve),
                        meta: {
                            title: "贝猎网-职位订阅"
                        }
                    }
                    ]
                },
                {
                    path: '/hunterHome/:hunterName',
                    name: 'hunterHome',
                    component: resolve => require(['@/pages/hunterHome'], resolve),
                    meta: {
                        title: "贝猎网-猎头主页"
                    }
                },
                {
                    path: '/recruit-sh',
                    name: 'sh',
                    component: resolve => require(['@/pages/recruit/sh'], resolve),
                    meta: {
                        title: '贝猎网-优质高薪，招聘专场'
                    }
                },
                {
                    path: '/recruit-hz',
                    name: 'hz',
                    component: resolve => require(['@/pages/recruit/hz'], resolve),
                    meta: {
                        title: '贝猎网-优质高薪，招聘专场'
                    }
                },
                {
                    path: '/recruit-sz',
                    name: 'sz',
                    component: resolve => require(['@/pages/recruit/sz'], resolve),
                    meta: {
                        title: '贝猎网-优质高薪，招聘专场'
                    }
                },
                {
                    path: '/recruit-bj',
                    name: 'bj',
                    component: resolve => require(['@/pages/recruit/bj'], resolve),
                    meta: {
                        title: '贝猎网-优质高薪，招聘专场'
                    }
                },
                {
                    path: '/recruit-wh',
                    name: 'wh',
                    component: resolve => require(['@/pages/recruit/wh'], resolve),
                    meta: {
                        title: '贝猎网-优质高薪，招聘专场'
                    }
                },
                {
                    path: '/recruit-gz',
                    name: 'gz',
                    component: resolve => require(['@/pages/recruit/gz'], resolve),
                    meta: {
                        title: '贝猎网-优质高薪，招聘专场'
                    }
                },
                {
                    path: '/chat',
                    name: 'chat',
                    component: resolve => require(['@/pages/chat'], resolve),
                    meta: {
                        title: '贝猎网-嗨职聊'
                    }
                },
                {
                    path: '/ruler',
                    name: 'ruler',
                    component: resolve => require(['@/pages/ruler'], resolve),
                    meta: {
                        title: '贝猎网-求职攻略'
                    }
                },
                {
                    path: '/acticle',
                    name: 'acticle',
                    component: resolve => require(['@/pages/acticle'], resolve),
                    meta: {
                        title: '贝猎网-资讯'
                    }
                },
                {
                    path: '/tutorials/:id',
                    name: 'articleDetail',
                    component: resolve => require(['@/pages/articleDetail'], resolve),
                },
                {
                    path: '/Agreement',
                    name: 'Agreement',
                    component: resolve => require(['@/pages/Agreement'], resolve),
                    meta: {
                        title: "贝猎网-求职者 用户服务协议"
                    }
                },
                {
                    path: '/huntingIntroduction',
                    name: 'huntingIntroduction',
                    component: resolve => require(['@/pages/huntingIntroduction'], resolve),
                    meta: {
                        title: "贝猎网-认证信息"
                    }
                },
                {
                    path: '/companyInfomation',
                    name: 'companyInfomation',
                    component: resolve => require(['@/pages/companyInfomation'], resolve),
                    meta: {
                        title: "贝猎网-企业详情"
                    },
                    beforeEnter: (to, from, next) => {
                        store.dispatch("homePageHeadInfo", null);
                        store.dispatch("descriptionInfo", null);
                        store.dispatch("developmentInfo", null);
                        store.dispatch("welfareOthersInfo", null);
                        store.dispatch("leadTeamInfo", null);
                        store.dispatch("locationInfo", null);
                        store.dispatch("environmentPhotoPathInfo", null);
                        store.dispatch("certificationInfo", null);
                        next();
                    },
                    children: [{
                        path: 'companyIntroduction',
                        name: 'companyIntroduction',
                        component: resolve => require(['@/pages/companyInfomation/components/companyIntroduction'], resolve),
                    },
                    {
                        path: 'hotPosition',
                        name: 'hotPosition',
                        component: resolve => require(['@/pages/companyInfomation/components/hotPosition'], resolve),
                    }
                    ]
                },
            ].concat(FooterRoute)
        }
    ]
})

export default router;
